import { RigidBody } from '@react-three/rapier';
import { useGLTF } from '@react-three/drei';
import { useMemo } from 'react';
import * as THREE from 'three';

export const Bridge = () => {
    // Place a bridge where the river (z ~ 30) crosses the center or a road.
    // Our central hub is < 15 radius.
    // River is z = sin(x)*10 + 30.
    // At x=0, z=30.
    // So let's build a bridge at x=0, z=30.

    const { scene } = useGLTF('/assets/Blender/GLB/curvedBridge.glb');
    const prepared = useMemo(() => {
        const clone = scene.clone(true);
        // User says river is wider than bridge, need to scale up
        const scale = 2.5; // Increased from 1.6
        clone.scale.setScalar(scale);
        clone.traverse((obj) => {
            const mesh = obj as THREE.Mesh;
            if (mesh.isMesh) {
                mesh.castShadow = true;
                mesh.receiveShadow = true;
            }
        });
        const box = new THREE.Box3().setFromObject(clone);
        const yOffset = -box.min.y;
        clone.position.y += yOffset;
        return clone;
    }, [scene]);

    // River crosses x=0 around z=-108. Let's place bridge there.
    // Also rotate slightly to align with river flow (Slope ~1.25) => perpendicular slope ~ -0.8
    // Angle = atan(-0.8) ~ -38 deg.
    // Banks are at roughly Y=0 (dist < 22 is flat 0, others rolling). -108 is far from 22.
    // Check height at banks:
    // getHeight(0, -108) -> River (-8)
    // Banks are roughly +/- 10 from center of river path.
    // Let's explicitly set Y to ground level near banks, say Y=-1 or 0.
    return (
        <group position={[0, -0.5, -108]} rotation={[0, -0.6, 0]}>
            <RigidBody type="fixed" colliders="cuboid">
                <primitive object={prepared} />
            </RigidBody>
        </group>
    );
};

useGLTF.preload('/assets/Blender/GLB/curvedBridge.glb');
